module.exports = __webpack_public_path__ + "img/dotted-arrow-down.9b0f0426.svg";